export default "\r\n<div class=\"my-3\">\r\n  <h1>Page Not Found!</h1>\r\n</div>\r\n"